module.exports = __webpack_public_path__ + "static/media/Eric Fain.0e713f1a.png";